// @ts-ignore
import profileImage from "../../../../assets/images/profilepic.png";
import { MapPinIcon } from "lucide-react";

const LivePreview = () => {
  return (
    <div className="rounded-md bg-white flex flex-col flex-1 gap-4 px-4 pt-4 pb-10 h-max">
      <div className="flex justify-between items-center h-max w-full">
        <div className="flex flex-col">
          <span className="font-semibold text-sm">Live profile preview</span>
          <span className="text-xss font-medium text-light-black">
            Basic preview using details from steps 1 and 2 only.
          </span>
        </div>
        <div className="flex items-center justify-center rounded-full bg-blue-50 text-blue-600 h-max font-semibold text-xss px-2 py-0.5">
          Basic Profile
        </div>
      </div>

      <div className="rounded-md border p-4">
        <div className="flex items-center gap-4">
          <div className="h-28 w-28 rounded-full border flex items-center justify-center bg-slate-50">
            {true ? (
              <img src={profileImage} className="h-full w-full" />
            ) : (
              <span className="font-bold text-4xl">MC</span>
            )}
          </div>
          <div className="flex flex-col">
            <span className="font-semibold">Alex Morgan</span>
            <span className="text-xss font-medium text-light-black mt-1">
              Data Analyst
            </span>
            <div className="flex items-center gap-1 mt-1">
              <MapPinIcon size={12} color="gray" />
              <span className="text-xss font-medium text-light-black">
                London, UK
              </span>
            </div>
          </div>
        </div>

        <div className="flex items-center my-4 gap-3">
          <div className="bg-blue-50 text-blue-600 rounded-full text-xss font-semibold px-2 py-1">
            Technology/Software
          </div>
          <div className="bg-gray-50 text-gray-600 rounded-full text-xss font-semibold px-2 py-1">
            Step 1 + 2 details only
          </div>
        </div>

        <div className="text-xs font-medium p-2.5 border rounded-md bg-white text-light-black leading-5">
          Once generated, candidates can continue adding preferences, summary,
          skills, experience and education to complete the full profile.
        </div>
      </div>
    </div>
  );
};

export default LivePreview;
